module.exports = __webpack_public_path__ + "img/132.52e08248.png";